import type { Account as GQLAccount, FeatureAccount as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util';
import type * as Account from '../Account/Account';

/** An account paired with whether it holds the feature flag the read was keyed on. */
export type FeatureAccount = {
  account: Account.Account;
  holdsFeature: boolean;
};

// Not `Account.fromGql`: its input type is `AccountSummary`, and the schema resolves the full
// `Account` here, whose `__typename` literal will not unify with it.
export const fromGql = (item: GQLItem): FeatureAccount => ({
  account: take<Account.Account, Pick<GQLAccount, 'id' | 'name'>>(item.account, 'id', 'name'),
  holdsFeature: item.holdsFeature,
});

export const fromGqlCollection = (items: GQLItem[]): FeatureAccount[] => items.map(fromGql);
